import { Entity } from "@jobilla/entity";

export class OrderItemsTransferDetails extends Entity {
  companyId!: number;
  companyName!: string;
  createdAt!: string;
  order!: number;
  orderItem!: number;
}
